module.exports = __webpack_public_path__ + "img/error-form.1a2c604b.svg";